import axios from '../helpers/bearerAxios';
import { logger } from './loggingService';

const baseURL = import.meta.env.VITE_BASE_URL!;

const getModuleList = async (stateCode: string) => {
    try {
        const response = await axios.post(
            baseURL + import.meta.env.VITE_MODULE_LIST_API_URL,
            {
                "StateCode": stateCode
            }
        );
        return response.data;
    } catch (error) {
        logger.error(error);
        return error;
    }
};

const moduleServices = {
    getModuleList
};

export default moduleServices;